module.exports = __webpack_public_path__ + "img/graf_linha.c9da5b8c.png";